module.exports = {
          srcSet: __webpack_public_path__ + "public/images/d2db5f863e5fdece49ce0340bba1a9d3-1774.webp"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/d2db5f863e5fdece49ce0340bba1a9d3-1774.webp",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/d2db5f863e5fdece49ce0340bba1a9d3-1774.webp",
          toString:function(){return __webpack_public_path__ + "public/images/d2db5f863e5fdece49ce0340bba1a9d3-1774.webp"},
          
          width: 1774,
          height: 887
        }